import React, { useEffect, useState } from 'react';
import './Dashboard.css';

function Dashboard() {
    const [catopt, setCatopt] = useState('none');
    const [catval, setCatval] = useState('Category');
    const [loaderdis, setLoaderdis] = useState('none');
    const [poptxt, setPoptxt] = useState('');
    const [poperr, setPoperr] = useState('');
    const [features, setFeatures] = useState([
        { name: "Material", description: "" },
        { name: "Size (inches)", description: "" },
        { name: "Capacity", description: "" },
        { name: "Care Instruction", description: "" }
    ]);
    const [images, setImages] = useState([]);
    const [previewUrls, setPreviewUrls] = useState([]);

    const [formdata, setFormdata] = useState({
        name: "",
        category: "",
        images: [],
        discountprice: 0,
        description: "",
        features: { name: '', description: '' }
    });

    const addFeatures = () => setFeatures(prev => [...prev, { name: "", description: "" }]);

    const featNameChange = (e, ind) => {
        const newarr = [...features];
        newarr[ind].name = e.target.value;
        setFeatures(newarr);
    };

    const featDescChange = (e, ind) => {
        const newarr = [...features];
        newarr[ind].description = e.target.value;
        setFeatures(newarr);
    };

    const featDelFunc = (ind) => {
        if (features.length > 1) {
            const newarr = [...features];
            newarr.splice(ind, 1);
            setFeatures(newarr);
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImages(prev => [...prev, file]);
        setPreviewUrls(prev => [...prev, URL.createObjectURL(file)]);
        e.target.value = "";
    };

    const removeImage = (index) => {
        setImages(prev => prev.filter((_, i) => i !== index));
        setPreviewUrls(prev => prev.filter((_, i) => i !== index));
    };

    useEffect(() => { setFormdata(prev => ({ ...prev, category: catval })); }, [catval]);
    useEffect(() => { setFormdata(prev => ({ ...prev, features: features })); }, [features]);

    const validateFormData = () => {
        const { name, category, discountprice, description } = formdata;
        if (!name || !discountprice || !category || !description || features.length === 0 || images.length === 0) {
            setPoperr("Please fill all required fields.");
            setTimeout(() => setPoperr(''), 3000);
            return false;
        }
        if (features.some(item => !item.name || !item.description)) {
            setPoperr("Please complete all feature fields.");
            setTimeout(() => setPoperr(''), 3000);
            return false;
        }
        return true;
    };

    const uploadFunc = async () => {
        if (!validateFormData()) return;
        setLoaderdis('flex');
        try {
            const imgFormData = new FormData();
            images.forEach(img => imgFormData.append('images', img));
            const imgRes = await fetch("https://pentadeco.in/api/uploadimg", { method: "POST", body: imgFormData });
            const imgData = await imgRes.json();
            if (!imgRes.ok || !imgData.success) throw new Error("Image upload failed");

            const prodRes = await fetch("https://pentadeco.in/api/uploadproduct", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    name: formdata.name,
                    category: formdata.category,
                    discountprice: formdata.discountprice,
                    description: formdata.description,
                    features: features,
                    images: imgData.urls || []
                })
            });
            const prodData = await prodRes.json();
            setLoaderdis('none');
            if (prodRes.ok && prodData.success) {
                setPoptxt("Product uploaded successfully");
                setTimeout(() => setPoptxt(''), 3000);
            } else throw new Error("Product upload failed");
        } catch (err) {
            setLoaderdis('none');
            setPoperr(err.message || 'Error occurred while uploading');
            setTimeout(() => setPoperr(''), 3000);
        }
    };

    const categories = [
        "Mug", "Bag Tag", "Mouse Pad", "Money Bank", "Wall Decor",
        "bags", "Mobile stand", "Wall clock", "tumblers", "Water bottle"
    ];

    return (
        <div className='main-dashboard'>
            <h2 className="body-font-bold fs-4 mt-3 mb-4">Upload Product</h2>

            <div className="upload-form-card">

                {/* Basic info */}
                <p className="upload-section-title">Basic Info</p>
                <div className="mb-3">
                    <label className="upload-form-label">Product Name <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="upload-form-input"
                        placeholder="e.g. Customised Magic Mug"
                        value={formdata.name}
                        onChange={e => setFormdata(x => ({ ...x, name: e.target.value }))}
                    />
                </div>
                <div className="row g-3 mb-3">
                    <div className="col-md-6">
                        <label className="upload-form-label">Price (₹) <span className="text-danger">*</span></label>
                        <input
                            type="number"
                            className="upload-form-input"
                            placeholder="e.g. 499"
                            value={formdata.discountprice}
                            onChange={e => setFormdata(x => ({ ...x, discountprice: e.target.value }))}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="upload-form-label">Category <span className="text-danger">*</span></label>
                        <div
                            className="upload-form-input d-flex justify-content-between align-items-center"
                            style={{cursor:'pointer'}}
                            onClick={() => setCatopt(catopt === 'none' ? 'block' : 'none')}
                        >
                            <span style={{textTransform:'capitalize', color: catval === 'Category' ? '#aaa' : '#222'}}>{catval}</span>
                            <i className="fas fa-chevron-down text-muted" style={{fontSize:'0.75rem'}}></i>
                        </div>
                        <div className="category-options-wrap" style={{ display: catopt }}>
                            {categories.map(cat => (
                                <p key={cat} onClick={() => { setCatopt('none'); setCatval(cat.toLowerCase()); }}>{cat}</p>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="mb-0">
                    <label className="upload-form-label">Description <span className="text-danger">*</span></label>
                    <textarea
                        rows={3}
                        className="upload-form-input"
                        placeholder="Describe your product..."
                        value={formdata.description}
                        onChange={e => setFormdata(x => ({ ...x, description: e.target.value }))}
                    ></textarea>
                </div>

                <hr className="upload-divider" />

                {/* Features */}
                <p className="upload-section-title">Specifications / Features</p>
                {features.map((feat, ind) => (
                    <div key={ind} className="feature-row">
                        <input
                            type="text"
                            className="upload-form-input"
                            placeholder="Feature (e.g. Material)"
                            value={feat.name}
                            onChange={e => featNameChange(e, ind)}
                            style={{flex:'0 0 36%', maxWidth:'36%'}}
                        />
                        <input
                            type="text"
                            className="upload-form-input"
                            placeholder="Value (e.g. Ceramic)"
                            value={feat.description}
                            onChange={e => featDescChange(e, ind)}
                        />
                        <button className="feature-del-btn" onClick={() => featDelFunc(ind)}>
                            <i className="fas fa-trash-alt"></i>
                        </button>
                    </div>
                ))}
                <button className="add-feature-btn" onClick={addFeatures}>
                    <i className="fas fa-plus"></i> Add Feature
                </button>

                <hr className="upload-divider" />

                {/* Images */}
                <p className="upload-section-title">Product Images</p>
                <input
                    type="file"
                    className="upload-form-input"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{padding:'8px 12px', cursor:'pointer'}}
                />
                <p className="text-muted mt-1 mb-0" style={{fontSize:'0.72rem'}}>Click to add more images one by one</p>
                {previewUrls.length > 0 && (
                    <div className="img-preview-grid">
                        {previewUrls.map((url, i) => (
                            <div key={i} style={{position:'relative', display:'inline-block'}}>
                                <img src={url} alt={`preview-${i}`} className="img-preview-item" />
                                <button
                                    onClick={() => removeImage(i)}
                                    style={{
                                        position:'absolute', top:'-6px', right:'-6px',
                                        width:'20px', height:'20px', borderRadius:'50%',
                                        background:'#c0392b', color:'#fff', border:'none',
                                        fontSize:'0.6rem', cursor:'pointer', display:'flex',
                                        alignItems:'center', justifyContent:'center'
                                    }}
                                >×</button>
                            </div>
                        ))}
                    </div>
                )}

                <hr className="upload-divider" />

                <button className="upload-submit-btn" onClick={uploadFunc}>
                    <i className="fas fa-cloud-upload-alt"></i> Upload Product
                </button>
            </div>

            {/* Loader */}
            <div className="full-overlay" style={{ display: loaderdis }}>
                <div className="loader-wrap rounded-brand p-4">
                    <div className="loader-roundedr"></div>
                </div>
            </div>

            {/* Toasts */}
            {poptxt && <div className="upload-toast upload-toast-success"><i className="fas fa-check-circle me-2"></i>{poptxt}</div>}
            {poperr && <div className="upload-toast upload-toast-error"><i className="fas fa-exclamation-circle me-2"></i>{poperr}</div>}
        </div>
    );
}

export default Dashboard;
